"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var styles = (0, _emotion.css)({
  display: "block",
  // The diamond has to poke out of the viewbox ever so slightly to appear of
  // similar size to the other symbols. The human mind is an amazing thing.
  overflow: "visible"
});
/**
 * Renders the various symbols (e.g. circle, square, etc.) that can be used to
 * uniquely identify different items in a legend.
 */

var LegendSymbol = function LegendSymbol(_ref) {
  var type = _ref.type,
      color = _ref.color,
      size = _ref.size;

  // If the "type" is a function (custom render), call the function with the color
  if (typeof type === "function") {
    return type({
      color: color
    });
  } // Else generate a predetermined shape


  var shape;

  if (type === "square") {
    shape = /*#__PURE__*/_react["default"].createElement("path", {
      d: "M -0.886 -0.886 H 0.886 V 0.886 H -0.886 Z",
      fill: color
    });
  } else if (type === "diamond") {
    shape = /*#__PURE__*/_react["default"].createElement("path", {
      d: "M -0.82 -0.82 H 0.82 V 0.82 H -0.82 Z",
      fill: color,
      transform: "rotate(45)"
    });
  } else if (type === "triangleUp" || type === "triangleDown") {
    shape = /*#__PURE__*/_react["default"].createElement("path", {
      d: "M 1 0.9 L -1 0.9 L 0 -0.9 Z",
      fill: color,
      transform: "rotate(".concat(type === "triangleDown" ? 180 : 0, ")")
    });
  } // Default to the circle... that's what Victory does too
  else {
    shape = /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "0",
      cy: "0",
      r: "1",
      fill: color
    });
  }

  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "-1 -1 2 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    role: "presentation",
    className: styles
  }, shape);
};

LegendSymbol.displayName = "LegendSymbol";
LegendSymbol.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].number,
  type: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].oneOf(["circle", "diamond", "square", "triangleDown", "triangleUp"])])
} : {};
LegendSymbol.defaultProps = {
  size: 14,
  type: "circle"
};
var _default = LegendSymbol;
exports["default"] = _default;